/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_ADJUSTED_DISPLAY_OBJ_CLAIM =
  'GET_CURRENT_ADJUSTED_DISPLAY_OBJ_CLAIM';
export const GET_CURRENT_ADJUSTED_DISPLAY_DETAIL_OBJ_CLAIM =
  'GET_CURRENT_ADJUSTED_DISPLAY_DETAIL_OBJ_CLAIM';
export const GET_REBATE_PROGRAM_CLAIM = 'GET_REBATE_PROGRAM_CLAIM';
export const GET_REBATE_PROGRAM_NAME_CLAIM = 'GET_REBATE_PROGRAM_NAME_CLAIM';
export const GET_ERROR_MSG_ADJUSTED_CLAIM = 'GET_ERROR_MSG_ADJUSTED_CLAIM';
export const LEFT_SIDE_TABLEDETAILS = 'LEFT_SIDE_TABLEDETAILS';
export const RIGHT_SIDE_TABLEDETAILS = 'RIGHT_SIDE_TABLEDETAILS';
export const DUPLICATE_ERRORS = 'DUPLICATE_ERRORS';
export const NDC_LOADING = 'NDC_LOADING';
export const PAGINATION_DATA_SET = 'PAGINATION_DATA_SET';
export const SELECTED_LABELER_M = 'SELECTED_LABELER_M';
export const LOAD_DETAIL_SCR = 'LOAD_DETAIL_SCR';
export const SET_UNIT_CHANGED_TYPE = 'SET_UNIT_CHANGED_TYPE';
export const SET_DISPUTE_RESOLUTION = 'SET_DISPUTE_RESOLUTION';
export const SET_INVOICE_STATUS = 'SET_INVOICE_STATUS';
export const SET_SELECT_BY = 'SET_SELECT_BY';
export const SET_LABELER_LIST = 'SET_LABELER_LIST';
export const SET_LABELER_DATA = 'SET_LABELER_DATA';
export const SET_LABELER_INFO = 'SET_LABELER_INFO';
export const SET_LABELER_INFO_NAME = 'SET_LABELER_INFO_NAME';
export const SET_CLAIM_CATEGORY = 'SET_CLAIM_CATEGORY';
export const SET_CLAIM_NAME_CATEGORY = 'SET_CLAIM_NAME_CATEGORY';
export const SET_QUARTER_RANGE_CLAIMS = 'SET_QUARTER_RANGE_CLAIMS';
export const GET_DRUG_DATA_CLAIM = 'GET_DRUG_DATA_CLAIM';
export const GET_ADJUSTED_CLAIMS_UNIT_DATA = 'GET_ADJUSTED_CLAIMS_UNIT_DATA';
export const GET_ADJUSTED_CLAIMS_GRID_DATA = 'GET_ADJUSTED_CLAIMS_GRID_DATA';
export const GET_ADJUSTED_CLAIMS_DRUG_DATA = 'GET_ADJUSTED_CLAIMS_DRUG_DATA';
export const GET_ADJUSTED_CLAIMS_DRUG_DATA_NAME =
  'GET_ADJUSTED_CLAIMS_DRUG_DATA_NAME';
export const GET_ADJUSTED_CLAIMS_ALL_DATA = 'GET_ADJUSTED_CLAIMS_ALL_DATA';
export const REFRESH_NDC_DETAILS = 'REFRESH_NDC_DETAILS';

export const SET_DISPLAY_OBJ_ADJUSTED = 'SET_DISPLAY_OBJ_ADJUSTED';
export const GET_ERROR_MSG_NDC_DETAILS = 'GET_ERROR_MSG_NDC_DETAILS';
export const SET_PAGINATION_INDEX_ADJUTED_CLAIMS =
  'SET_PAGINATION_INDEX_ADJUTED_CLAIMS';
export const SET_DRUG_SEQ_NUMBER = 'SET_DRUG_SEQ_NUMBER';
export const SET_PROVIDER_CD = 'SET_PROVIDER_CD'